import { observer } from 'mobx-react-lite'
import { ActionCard } from '@/features/jobs/details/components/ActionCard'
import { Button } from '@/components/Button'
import { ScrolledAction } from '@/features/jobs/details/components/PageHeader'

interface RateJobActionBaseProps {
  onRatePress: () => unknown
  testId?: string
}

interface RateJobActionProps extends RateJobActionBaseProps {
  kicker: string
  title: string
}

/**
 * Action card on the job header to start the rating flow.
 */
export const RateJobActionCard = observer(function RateJobActionCard({
  onRatePress,
  kicker,
  title,
  testId,
}: RateJobActionProps) {
  return (
    <ActionCard kicker={kicker} title={title}>
      <Button
        label="Leave review"
        variant="outline"
        onPress={onRatePress}
        testId={testId}
      />
    </ActionCard>
  )
})

/**
 * Compact action shown in the scrolled page header to start the rating flow.
 */
export const RateJobScrolledAction = observer(function RateJobScrolledAction({
  onRatePress,
  testId,
}: RateJobActionBaseProps) {
  return (
    <ScrolledAction
      label="Leave review"
      onPress={onRatePress}
      testId={testId}
    />
  )
})
